import WebFont from 'webfontloader';

const load = () => {
    WebFont.load({
        google: {
            families: ['Roboto:100,300,400,500']
        }
    });
};

export default load;



// WEBPACK FOOTER //
// ./src/bootstrap/loadFonts.js